import axios from "axios";
import { browser, getPath, platform } from "../utils";
import config from "../config/ConfigApplication";
import history from "./history";
import { toast } from "react-toastify";
import { api } from "./api";
import { CD_CHANNEL_TRADEMAP } from "../constant/index.const";

const BASE_URL_RANDOM = "https://randomuser.me/api/";
const BASE_URL = getPath("/api/portal/");
const BASE_URL_TRADEMAP = getPath("/api/trademap/");
const BASE_URL_BILLING = getPath("/api/billing/");
const BASE_URL_AUTHENTICATION = getPath("/api/authentication/");
const BASE_URL_ADJUST = getPath("/api/adjust/");
const BASE_URL_TERMS = getPath("/api/terms/");

class HttpService extends api {
	/**
	 *
	 * @param {string} GET_BASE_URL
	 * @param {string} endpoint
	 * @param {'POST' | 'PUT'} method
	 * @param {*} data
	 * @param {boolean} withCredentials
	 * @param {*} header
	 * @returns
	 */
	async callApiMethod(
		GET_BASE_URL,
		endpoint,
		method = "POST",
		data = false,
		withCredentials = true,
		header = {}
	) {
		let result;
		const url = GET_BASE_URL + endpoint;
		try {
			var headers = header;
			headers["Content-Type"] = "application/json";
			const response = await axios[method.toLowerCase()](url, data, {
				headers: headers,
				withCredentials,
			});
			result = response.data;
		} catch (error) {
			result = error.response;

			console.error(
				`[${String(endpoint).split("/")[2].toUpperCase()} ERROR] ->`,
				error || `Houve um erro ao chamar o endpoint ${String(endpoint).toUpperCase()}`
			);

			if (Boolean(error) && error.response.status === 401) {
				toast.error("Sua sessão expirou, faça login novamente.");
				history.push("/onboard/login");
			}
		} finally {
			return result;
		}
	}

	async getRegionIp() {
		let ip = "0.0.0.0";

		try {
			ip = (await (await fetch("https://checkip.amazonaws.com/")).text()).trim();
		} catch (error) {
			console.error("[GET IP BY AMAZON ERROR]", error);
		}

		return ip;
	}

	async login(username, password, tokenRecaptcha = {}, idContract = 2020, channel = "13") {
		const body = {
			username,
			password,
			idContract,
			channel,
			info: {
				ip: "",
				os_version: "WEB",
				version: "",
				os_name: `${browser}, ${platform}`,
			},
		};

		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/authentication/login-trademap",
			"POST",
			body,
			true,
			tokenRecaptcha
		);
		return result;
	}

	/**
	 * @param {string} reason;
	 */
	async logout(reason) {
		return await this.post(BASE_URL_AUTHENTICATION, "v2/authentication/logout", {
			reason,
		});
	}

	async sendPhone(num, from_educa) {
		const body = { vl_full_phone_number: "+" + num, from_educa };
		const result = await this.callApiMethod(BASE_URL, "v1/onboard/initial-onboard", "POST", body);
		return result;
	}

	// NEW ACCOUNT API - START
	/**
	 *
	 * @param {number} socialOrigin
	 * @param {string} cdChannel
	 * @returns
	 */
	async initialOnboard(socialOrigin, cdChannel) {
		return this.post(BASE_URL_TRADEMAP, "v1/onboard/initial-onboard", {
			socialOrigin,
			cdChannel,
		});
	}

	/**
	 *
	 * @param {{cd_access_token: string, cd_channel: string, header: object}} payload
	 * @returns
	 */
	async validateInitialOnboardEmail(payload) {
		const { cd_access_token, cd_channel, header } = payload;

		return this.post(
			BASE_URL_TRADEMAP,
			"v1/onboard/validateInitialOnboardEmail",
			{ cd_access_token, cd_channel, os_name: "WEB" },
			header
		);
	}

	/**
	 *
	 * @param {{cd_access_token: string, cd_channel: string, header: object}} payload
	 * @returns
	 */
	async validateInitialOnboard(payload) {
		const { cd_access_token, cd_channel, header } = payload;

		return this.post(
			BASE_URL_TRADEMAP,
			"v1/onboard/validateInitialOnboard",
			{ cd_access_token, cd_channel, os_name: "WEB" },
			header
		);
	}

	/**
	 *
	 * @param {{cd_access_token: string, email: string, verification: string}} payload
	 * @returns
	 */
	async emailConfirmation(payload) {
		return this.post(BASE_URL_TRADEMAP, "v1/onboard/emailConfirmation", payload);
	}

	/**
	 *
	 * @param {{cd_access_token: string,vl_full_phone_number: string}} payload
	 * @returns
	 */
	async resendPhoneConfirmation(payload) {
		return this.post(BASE_URL_TRADEMAP, "v1/onboard/resendPhoneConfirmation", payload);
	}

	/**
	 *
	 * @param {{cd_access_token: string, vl_full_phone_number: string, verification: string}} payload
	 * @returns
	 */
	async phoneConfirmation(payload) {
		return this.post(BASE_URL_TRADEMAP, "v1/onboard/phoneConfirmation", payload);
	}

	/**
	 *
	 * @param {{cd_access_token: string, is_term_accepted: boolean, cd_channel: string}} payload
	 * @returns
	 */
	async onboardGogogoV2(payload) {
		return this.post(BASE_URL_TRADEMAP, "v1/onboard/onboardGogogoV2", payload);
	}

	/**
	 *
	 * @param {string} field
	 * @param {string} value
	 * @param {string | boolean} extra
	 * @param {boolean} is_edition
	 * @returns
	 */
	async updateOnboardField(field, value, extra = false, is_edition = false) {
		const cd_access_token = sessionStorage.getItem("cd_access_token");
		const body = { cd_access_token, field, value };

		if (extra) body.extra = extra;
		if (is_edition) body.is_edition = is_edition;

		const result = await this.post(BASE_URL_TRADEMAP, "v1/onboard/update-onboard-field", body);
		return result;
	}

	/**
	 *
	 * @param {string} cd_access_token
	 * @returns
	 */
	async getEmailProductActivations(cd_access_token) {
		return this.post(BASE_URL_TRADEMAP, "v1/onboard/getEmailProductActivations", { cd_access_token });
	}

	// NEW ACCOUNT API - END

	async reSendPhone(num) {
		const cd_access_token = sessionStorage.getItem("cd_access_token");
		const body = { cd_access_token, vl_full_phone_number: num };
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v4/onboard/resend-phone-confirmation",
			"POST",
			body
		);
		return result;
	}

	async registerCelPhone(cd_access_token, vl_full_phone_number, operation_system, type_to_send) {
		const body = { cd_access_token, vl_full_phone_number, operation_system, type_to_send };
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v9/onboard/register-cel-phone",
			"POST",
			body
		);
		return result;
	}

	async validatePhoneToken(verification) {
		const vl_full_phone_number = sessionStorage.getItem("vl_full_phone_number");
		const body = {
			verification,
			phone_number: vl_full_phone_number.replace("+", ""),
		};
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v2/portal/validate-phone-token",
			"POST",
			body
		);
		return result;
	}
	async tokenConfirmation(verification) {
		const cd_access_token = sessionStorage.getItem("cd_access_token");
		if (cd_access_token === "SKIP_STEP_TOKEN") {
			const resp = this.validatePhoneToken(verification);
			return resp;
		}
		const vl_full_phone_number = sessionStorage.getItem("vl_full_phone_number");
		const body = {
			cd_access_token,
			verification,
			vl_full_phone_number: vl_full_phone_number.replace("+", ""),
		};
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v4/onboard/phone-confirmation",
			"POST",
			body
		);
		return result;
	}

	async saveOnboardEvent(onboardEvent) {
		const cd_access_token = sessionStorage.getItem("cd_access_token");
		const resp = await this.callApiMethod(BASE_URL_TRADEMAP, "v8/onboard/save-onboard-event", "POST", {
			cd_access_token,
			onboardEvent,
		});
		sessionStorage.removeItem("cd_access_token");
		return resp;
	}

	/**
	 *
	 * @deprecated
	 */
	async onboardGogogo(password, isTermAccepted) {
		const cd_access_token = sessionStorage.getItem("cd_access_token");
		const is_term_accepted = isTermAccepted;
		const body = { cd_access_token, password, is_term_accepted };
		const response = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v8/onboard/onboard-gogogo",
			"POST",
			body
		);
		return response;
	}

	async setInvestorMGM(username) {
		const userName = username;
		const body = { userName };
		const response = await this.callApiMethod("/api/", "awards/v1/mgm/new-invite", "POST", body);
		return response;
	}

	async getAddressByCep(cep) {
		const body = { cep };
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v3/onboard/getAddressByCep",
			"POST",
			body
		);
		return result;
	}

	async getCountries() {
		const result = await this.callApiMethod(BASE_URL_TRADEMAP, "v3/onboard/getCountries", "POST");
		return result;
	}

	async updateAddress(payload) {
		const body = payload;
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v3/onboard/updateAddress",
			"POST",
			body
		);
		return result;
	}

	//PAGAMENTOS
	async getBillingPlans(payload) {
		const body = payload;
		const result = await this.callApiMethod(BASE_URL_BILLING, "v9/plans/getBillingPlans", "POST", body);
		return result;
	}

	async getAddressByIdInvestor() {
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v3/onboard/getAddressByIdInvestor",
			"POST"
		);
		return result;
	}

	async getLastActivePlanStatus() {
		//const body = { credentials: 'include' }
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v9/plans/getLastActivePlanStatus",
			"POST"
		);
		return result;
	}

	async getLastActivePlanStatusXHR() {
		var xhr = new XMLHttpRequest();
		xhr.open("POST", BASE_URL + "v1/onboard/initial-onboard");
		xhr.onload = function () {
			if (xhr.status === 200) {
				alert("User's name is " + xhr.responseText);
			} else {
				alert("Request failed.  Returned status of " + xhr.status);
			}
		};
		xhr.send();
		//const result = await this.callApiMethod(BASE_URL, 'v1/plans/getLastActivePlanStatus', 'POST')
		return {};
	}

	async processBillingPlan(payload) {
		const body = payload;
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v9/plans/process-billing-plan",
			"POST",
			body
		);
		return result;
	}

	async getInvestorCreditCards() {
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/creditCard/get-investor-credit-cards",
			"POST",
			{}
		);
		return result;
	}

	async addCardToCustomer(payload) {
		const body = payload;
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/creditCard/add-card-to-customer",
			"POST",
			body
		);
		return result;
	}

	async updateBillingCard(payload) {
		const body = payload;
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/creditCard/update-billing-card",
			"POST",
			body
		);
		return result;
	}

	async getRandomUser() {
		let result;
		const endpoint = "?nat=br&randomapi";
		try {
			const response = await fetch(BASE_URL_RANDOM + endpoint);
			result = response.json();
		} catch (error) {
			console.error("error", error);
			result = error;
		}
		return result;
	}

	async getAuthToken() {
		const result = await this.callApiMethod(BASE_URL_TRADEMAP, "v2/qr-auth/auth-token", null, true);

		return result;
	}

	async getAccessToken(cd_auth_token) {
		return await this.callApiMethod(BASE_URL_TRADEMAP, "v2/qr-auth/access-token", null, {
			cd_auth_token,
		});
	}

	async getSessionToken(cd_access_token) {
		return await this.callApiMethod(BASE_URL_TRADEMAP, "v2/qr-auth/session-token", null, {
			cd_access_token,
		});
	}

	async tokenLoginTM(token) {
		const channel = config.channel || 13;
		const id_contract = config.id_contract || 2020;

		const resp = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/authentication/login-by-token",
			null,
			{
				token,
				channel,
				id_contract,
				info: {
					os_version: "",
					version: "",
					os_name: "",
				},
			}
		);
		return resp;
	}
	async loginUsingExternalToken(token) {
		const resp = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/authentication/login-using-external-token",
			null,
			{
				token,
			}
		);
		return resp;
	}
	async loginUsingSessionToken(token) {
		const resp = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/authentication/login-using-session-token",
			null,
			{
				token,
			}
		);
		return resp;
	}

	async getLastToken() {
		return await this.callApiMethod(BASE_URL_TRADEMAP, "v2/portal/get-last-token", {});
	}

	async authorizeAuthToken(cd_auth_token, cd_device) {
		return await this.callApiMethod(BASE_URL_TRADEMAP, "v2/qr-auth/authorize-auth-token", null, {
			cd_auth_token,
			cd_device,
		});
	}

	async veryfyCoupon(id_plan, cd_coupon) {
		return await this.callApiMethod(BASE_URL_BILLING, "v9/plans/verify-coupon", "POST", {
			id_plan,
			cd_coupon,
		});
	}

	async verifyHealth() {
		return await this.callApiMethod(BASE_URL_TRADEMAP, "v1/session/alive", "POST", {});
	}

	async verifyEmail() {
		return await this.callApiMethod(BASE_URL_TRADEMAP, "v1/investor/verify-email", "POST", {});
	}

	async updateEmail(email) {
		return await this.callApiMethod(BASE_URL_TRADEMAP, "v1/investor/update-email", "POST", {
			email,
		});
	}

	async getBillingPlanById(id_plan) {
		return await this.callApiMethod(BASE_URL_BILLING, "v9/plans/get-billing-plan-by-id", "POST", {
			id_plan,
		});
	}

	async getResearchByPlan(id_plan, cd_promotional = null) {
		return await this.callApiMethod(BASE_URL_BILLING, "v9/plans/getResearchByPlan", "POST", {
			id_plan,
			cd_promotional,
		});
	}
	/**
	 *
	 * @deprecated this enpoint is not used. Was used in confirmation of payment
	 */
	async saveTermsUserAcceptance(id_research) {
		return await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v9/research/save-terms-user-acceptance",
			"POST",
			{
				id_research,
			}
		);
	}

	async isResearchTermAccepted(id_research) {
		return await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v9/research/is-research-term-accepted",
			"POST",
			{
				id_research,
			}
		);
	}

	async getMicroServices(operating_system) {
		return await this.callApiMethod(BASE_URL_BILLING, "v2/micro-service/get-micro-services", "POST", {
			operating_system,
		});
	}
	async getInvestorMicroServices() {
		return await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/micro-service/get-investor-micro-services",
			"POST",
			{}
		);
	}

	async doCheckout(payload) {
		const body = payload;
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/micro-service/do-checkout",
			"POST",
			body
		);
		return result;
	}
	async doSpotCheckout(payload) {
		const body = { id_micro_service: payload.services[0].id_micro_service };
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/micro-service/do-spot-checkout",
			"POST",
			body
		);
		return result;
	}
	async getPlanByCode(code) {
		const body = {
			cd_plan: code,
		};
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v9/plans/get-billing-plan-by-cd",
			"POST",
			body
		);
		return result;
	}
	/**
	 * sso: string, sig: string
	 */
	async authenticateSocialMediaLogin(sso, sig) {
		const body = {
			sso,
			sig,
		};
		try {
			const result = await this.callApiMethod(
				BASE_URL_TRADEMAP,
				"v9/authentication/authenticate-social-media-login",
				"POST",
				body
			);
			return result;
		} catch (error) {
			console.error("[error] - ", error);
		}
	}

	async getPaymentMode(id_product) {
		const body = {
			id_product: id_product,
		};
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/payment/get-payment-mode",
			"POST",
			body
		);
		return result;
	}

	async getProductByCode(cd_product) {
		const body = {
			cdProduct: cd_product,
		};
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/product/get-products-by-cd-product",
			"POST",
			body
		);
		return result;
	}

	async doPayment(payload) {
		const body = payload;
		// const result = await {
		//   "success": true,
		//   "result": {
		//       "success": true,
		//       "url_boleto": "https://api.mundipagg.com/core/v1/transactions/tran_Xg5PQ3lipFyazApN/pdf"
		//   }
		// }
		const result = await this.callApiMethod(BASE_URL_BILLING, "v1/payment/do-payment", "POST", body);
		return result;
	}

	async getTypeRecurrenceDefault(id_product) {
		const body = {
			idProduct: id_product,
		};
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/product/get-type-recurrence-default",
			"POST",
			body
		);
		return result;
	}

	async getMicroServiceDetailByCdPromotion(cdPromotional) {
		const body = {
			cdPromotional,
			operatingSystem: "WEB",
		};

		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/product/get-micro-service-detail-by-cd-promotional",
			"POST",
			body
		);

		return result;
	}

	async getPlanDetailByCdPromotional(cdPromotional) {
		const body = {
			cdPromotional,
			operatingSystem: "WEB",
		};

		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v2/product/get-plan-detail-by-cd-promotional",
			"POST",
			body
		);

		return result;
	}

	async verifyCoupon(id_product, cd_coupon) {
		const body = {
			id_product: id_product,
			cd_coupon: cd_coupon,
		};
		const result = await this.callApiMethod(BASE_URL_BILLING, "v1/payment/verify-coupon", "POST", body);
		return result;
	}

	async newInvestor(info) {
		const body = { info };
		const result = await this.callApiMethod(BASE_URL_TRADEMAP, "v1/onboard/new-investor", "POST", body);
		return result;
	}

	async registrationNovadax(body) {
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/integration/register-customer",
			"POST",
			body
		);
		return result;
	}

	async sendPinCode(name, email) {
		const body = {
			name: name,
			email: email,
		};

		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/integration/send-email-code",
			"POST",
			body
		);
		return result;
	}

	async resendPincode(name, email) {
		const body = {
			name: name,
			email: email,
		};

		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/integration/resend-code",
			"POST",
			body
		);
		return result;
	}

	async verificationPincode(email, pinCode) {
		const body = {
			email: email,
			pinCode: pinCode,
		};

		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/integration/verification-code",
			"POST",
			body
		);
		return result;
	}

	async getBirthday(cnpj_cpf) {
		const body = cnpj_cpf;

		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/on-boarding/get-birthday",
			"POST",
			body
		);
		return result;
	}
	// RECOVER ACCOUNT API - START

	async requestAccountRecoverWithType(
		vlDocument,
		documentType,
		recoveryInfoType,
		recoveryInfo,
		operatingSystem,
		header
	) {
		const body = { vlDocument, documentType, recoveryInfoType, recoveryInfo, operatingSystem };
		body.cdChannel = CD_CHANNEL_TRADEMAP;

		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v4/password/requestAccountRecoverWithType",
			"POST",
			body,
			null,
			header
		);
		return result;
	}

	async requestAccountRecoverWithTypeME(payload, header) {
		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v4/password/requestAccountRecoverWithTypeME",
			"POST",
			payload,
			null,
			header
		);
		return result;
	}

	async doRecoverAccountWithType(token, type, value) {
		const body = { token, value, type };
		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v4/password/doRecoverAccountWithType",
			"POST",
			body
		);
		return result;
	}

	async changePasswordAfterValidate(token, new_password, new_confirm_password) {
		const body = { token, new_password, new_confirm_password };
		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v4/password/changePasswordAfterValidate",
			"POST",
			body
		);
		return result;
	}

	// RECOVER ACCOUNT API - END

	async loginWithToken(token) {
		const body = { token };
		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/authentication/login-with-token-checkout",
			"POST",
			body
		);
		return result;
	}

	async preLoginExternal() {
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v9/authentication/pre-login-external",
			"POST"
		);
		return result;
	}

	async scheduleHealthCheckAuthenticationWs() {
		const result = await this.callApiMethod(BASE_URL_AUTHENTICATION, "v1/session/alive", "POST", {});
		return result;
	}

	async reactiveSubscription() {
		return await this.callApiMethod(BASE_URL_BILLING, "v9/plans/reactivate-subscription", "POST");
	}

	async getValueProRataWithMicroServices(
		id_plan,
		cd_recurrence,
		id_research,
		cd_coupon,
		cd_promotional,
		qtt_installments
	) {
		const body = { id_plan, cd_recurrence, id_research, cd_coupon, cd_promotional, qtt_installments };
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v9/plans/get-value-pro-rata-plans-with-micro-services",
			"POST",
			body
		);
		return result;
	}

	async getActiveResearch() {
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v9/research/get-active-research",
			"POST",
			{}
		);
		return result;
	}

	async updatePlan(payload) {
		const body = payload;
		const result = await this.callApiMethod(BASE_URL_BILLING, "v9/plans/update-plan", "POST", body);
		return result;
	}

	async changeResearch({ id_research, password }) {
		const result = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v9/research/set-research-by-id",
			"POST",
			{ id_research, password }
		);
		return result;
	}

	async onboardingLogged(cdAccessToken) {
		const result = await this.callApiMethod(
			BASE_URL_BILLING,
			"v1/on-boarding/onboarding-logged",
			"POST",
			{
				cdAccessToken,
			}
		);
		return result;
	}

	async verifyDuplicityInEmail(email, cpf) {
		const resp = await this.callApiMethod(
			BASE_URL_TRADEMAP,
			"v9/onboard/verify-duplicity-email",
			"POST",
			{
				email,
				cpf,
			}
		);
		return resp;
	}

	async saveEvents(requests) {
		const result = await this.callApiMethod(BASE_URL_TRADEMAP, "v1/analytics/save-events", "POST", {
			requests,
		});
		return result;
	}

	async setAbandonedOnboardStatus() {
		if (localStorage.getItem("FLUX_INFLUENCER")) {
			localStorage.removeItem("FLUX_INFLUENCER");
		}

		const cd_access_token =
			sessionStorage.getItem("cd_access_token") || localStorage.getItem("cd_access_token");
		return this.callApiMethod(BASE_URL_TRADEMAP, "v9/onboard/set-abandoned-onboard-status", "POST", {
			cd_access_token,
		});
	}

	async updateAccountStatus(username) {
		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/authentication/update-account-status",
			"POST",
			{
				username,
			}
		);
		return result;
	}

	async socialLogin(token, socialNetworkId, idContract = "2020", channel = "13") {
		const body = {
			idContract,
			channel,
			token,
			socialNetworkId,
			info: {
				os_version: "",
				version: "",
				os_name: "",
			},
		};

		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/social/social-login",
			"POST",
			body
		);

		return result;
	}

	async associateSocialAccount(cdAccessToken, email, id, idSocial) {
		const body = {
			cdAccessToken,
			email,
			idSocialNetworkUser: id,
			idTmSocialNetworkType: idSocial,
		};

		const result = await this.callApiMethod(
			BASE_URL_AUTHENTICATION,
			"v1/social/associate-social-account",
			"POST",
			body
		);

		return result;
	}

	/**
	 *
	 * @param {{ signupStage: string, platform: "ANDROID" | "IOS" | "WEB", idAdjust: string, idInfluencerLink: number, idInvestor: number }} param
	 */
	async handleAdjustEvent(param) {
		return this.callApiMethod(BASE_URL_ADJUST, "v1/influencers/handleAdjustEvent", "POST", {
			...param,
		});
	}

	/**
	 * @param {number} idTerm
	 * @param {string} token
	 * @param {string} ip
	 * @returns {Promise<{"success": boolean, "result": boolean}>}
	 */
	async approveTerms(payload) {
		return await this.callApiMethod(BASE_URL_TERMS, "v2/approve", "POST", payload);
	}

	async ticketZendesk(payload) {
		return await this.post(BASE_URL_AUTHENTICATION, "v2/helpdesk/send-ticket-zenDesk", payload);
	}
}

export default new HttpService();
